import "../index.css";
import Footer from "../components/Footer";
//import { useAuth } from "../auth/context";
import { useRef, useEffect } from "react";
import { PageNav } from "../components/PageNav";
import apple_app from "../assets/apple-download.svg";
import google_app from "../assets/google-download.svg";
import chartsVideo from "../assets/charts.mp4";
import gamesVideo from "../assets/games.mp4";
//import title_image2 from "../assets/title_image.png";

function TitleText() {
  return (
    <div
      className="center_me border_radius"
      style={{
        padding: "1rem",
        flex: 1,
        flexDirection: "column",
        gap: "1rem",
        alignItems: "center",
        alignSelf: "stretch",
      }}
    >
      <div
        className="border_radius bold_text vertical_margin"
        style={{
          // padding: "1rem",
          fontSize: "2.5rem",
          fontFamily: "'Russo One', sans-serif",
          fontWeight: "400",
          textAlign: "center",
          letterSpacing: "2px",
          color: "#ff6b35",
        }}
      >
        Automated Sports Betting Made Easy
      </div>
    </div>
  );
}

function TitleImage1() {
  const videoRef = useRef<HTMLVideoElement>(null);

  const handleEnded = () => {
    setTimeout(() => {
      videoRef.current?.play();
    }, 30000);
  };

  return (
    <div
      className="center_me border_radius"
      style={{
        // padding: "1rem",
        flex: 1,
        flexDirection: "column",
        gap: "1rem",
        alignItems: "center",
        alignSelf: "stretch",
      }}
    >
      <video
        ref={videoRef}
        src={chartsVideo}
        width="300"
        autoPlay
        muted
        playsInline
        onEnded={handleEnded}
      />
    </div>
  );
}

function TitleImage2() {
  const videoRef = useRef<HTMLVideoElement>(null);

  const handleEnded = () => {
    setTimeout(() => {
      videoRef.current?.play();
    }, 30000);
  };

  return (
    <div
      className="center_me border_radius"
      style={{
        // padding: "1rem",
        flex: 1,
        flexDirection: "column",
        gap: "1rem",
        alignItems: "center",
        alignSelf: "stretch",
      }}
    >
      <video
        ref={videoRef}
        src={gamesVideo}
        width="300"
        autoPlay
        muted
        playsInline
        onEnded={handleEnded}
      />
    </div>
  );
}

function Info1() {
  return (
    <div
      className="center_me border_radius"
      style={{
        padding: "1rem",
        flex: 1,
        flexDirection: "column",
        gap: "1rem",
        alignItems: "flex-start",
        alignSelf: "stretch",
      }}
    >
      <div className="row center_me" style={{ width: "100%" }}>
        <div
          className="font_family_base center_me background_3 border_radius text-blue"
          style={{ padding: "1rem" }}
        >
          LIVE ODDS TRACKING
        </div>
      </div>
      <div className="row center_me" style={{ width: "100%" }}>
        <div
          className="font_family_base center_me background_3 border_radius"
          style={{ padding: "1rem", textAlign: "center" }}
        >
          Constant real-time odds from major sports books. View everything in a
          single location.
        </div>
      </div>
    </div>
  );
}

function Info2() {
  return (
    <div
      className="center_me border_radius"
      style={{
        padding: "1rem",
        flex: 1,
        flexDirection: "column",
        gap: "1rem",
        alignItems: "flex-start",
        justifyContent: "flex-start",
        alignSelf: "stretch",
      }}
    >
      <div className="row center_me" style={{ width: "100%" }}>
        <div
          className="font_family_base row center_me background_3 border_radius text-blue"
          style={{ padding: "1rem" }}
        >
          CUSTOM NOTIFICATIONS
        </div>
      </div>
      <div className="row center_me" style={{ width: "100%" }}>
        <div
          className="font_family_base row center_me background_3 border_radius"
          style={{ padding: "1rem", textAlign: "center" }}
        >
          Design your personalized plans for targeted betting opportunities
        </div>
      </div>
    </div>
  );
}

function Testimonials() {
  const testimonials = [
    {
      name: "Mike R.",
      role: "Professional Bettor",
      text: "StakeAlerts has completely transformed how I manage my betting strategy. The real-time notifications are a game changer!",
      rating: 5,
    },
    {
      name: "Sarah T.",
      role: "Sports Enthusiast",
      text: "I love how easy it is to set up custom alerts. No more missing out on great odds!",
      rating: 5,
    },
    {
      name: "Jason K.",
      role: "Casual Bettor",
      text: "The automated tracking saves me hours every week. Highly recommend for anyone serious about betting.",
      rating: 5,
    },
  ];

  return (
    <div
      className="center_me"
      style={{
        flexDirection: "column",
        marginTop: "40px",
        marginBottom: "40px",
        padding: "20px",
      }}
    >
      <h2
        className="font_family_base"
        style={{
          fontSize: "2rem",
          fontWeight: "bold",
          marginBottom: "30px",
          textAlign: "center",
        }}
      >
        What Our Users Say
      </h2>

      {/* Desktop - 3 columns */}
      <div className="show-desktop" style={{ width: "100%" }}>
        <div
          className="row"
          style={{
            gap: "20px",
            justifyContent: "center",
            alignItems: "stretch",
            width: "100%",
          }}
        >
          {testimonials.map((testimonial, index) => (
            <div
              key={index}
              className="background_3 border_radius font_family_base"
              style={{
                padding: "20px",
                flex: "1",
                maxWidth: "350px",
                border: "2px solid #007bff",
                display: "flex",
                flexDirection: "column",
                gap: "10px",
              }}
            >
              <div style={{ color: "#FFD700", fontSize: "1.2rem" }}>
                {"★".repeat(testimonial.rating)}
              </div>
              <p
                style={{
                  fontSize: "1rem",
                  lineHeight: "1.6",
                  fontStyle: "italic",
                  color: "#ddd",
                }}
              >
                "{testimonial.text}"
              </p>
              <div style={{ marginTop: "auto" }}>
                <div style={{ fontWeight: "bold", color: "#007bff" }}>
                  {testimonial.name}
                </div>
                <div style={{ fontSize: "0.9rem", color: "#aaa" }}>
                  {testimonial.role}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Mobile - 1 column */}
      <div className="show-mobile" style={{ width: "100%" }}>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "20px",
            alignItems: "center",
            width: "100%",
          }}
        >
          {testimonials.map((testimonial, index) => (
            <div
              key={index}
              className="background_3 border_radius font_family_base"
              style={{
                padding: "20px",
                width: "100%",
                maxWidth: "400px",
                border: "2px solid #007bff",
                display: "flex",
                flexDirection: "column",
                gap: "10px",
              }}
            >
              <div style={{ color: "#FFD700", fontSize: "1.2rem" }}>
                {"★".repeat(testimonial.rating)}
              </div>
              <p
                style={{
                  fontSize: "1rem",
                  lineHeight: "1.6",
                  fontStyle: "italic",
                  color: "#ddd",
                }}
              >
                "{testimonial.text}"
              </p>
              <div style={{ marginTop: "auto" }}>
                <div style={{ fontWeight: "bold", color: "#007bff" }}>
                  {testimonial.name}
                </div>
                <div style={{ fontSize: "0.9rem", color: "#aaa" }}>
                  {testimonial.role}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default function Home() {
  //   const { user, loading } = useAuth();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
      <PageNav />
      <div className="main_div">
        <div className="center_me">
          <a
            className=""
            href="https://apps.apple.com/us/app/stakealerts/id6760260873"
            target="_blank"
            rel="noopener noreferrer"
            style={{ marginRight: 10, marginLeft: 10 }}
          >
            <img
              src={apple_app}
              alt="Ios App"
              width="120"
              height="30"
              // style={{ height: 50, width: 50 }}
            />
          </a>
          <a
            className=""
            href="https://play.google.com/store/apps/details?id=com.stakealerts.stakealertsmobile"
            target="_blank"
            rel="noopener noreferrer"
            style={{ marginRight: 10, marginLeft: 10 }}
          >
            <img
              src={google_app}
              alt="Android App"
              width="120"
              height="30"
              // style={{ height: 50, width: 50 }}
            />
          </a>
        </div>
        {/* <div
          className="row center_me background_1 border_radius"
          style={{
            padding: "1rem",
            marginTop: "10px",
            marginRight: "10px",
            marginLeft: "10px",
          }}
        >
          <div
            className="font_family_base background_3 border_radius text-green"
            style={{ padding: "1rem" }}
          >
            Coming Soon or Deals
          </div>
          <div
            className="font_family_base center_me background_3 text-green border_radius"
            style={{ padding: "1rem", marginTop: "1rem", textAlign: "center" }}
          >
            At Stake Alerts, we are committed to simplifying the betting
            experience. Our platform empowers users to discover and act on their
            preferred betting opportunities without the time-comsuming process
            of manual research or navigating multiple applications. We provide a
            centralized, reliable, and user-focused solution that saves time and
            enhances decision-making.
          </div>
        </div> */}
        <div className="show-desktop">
          <div
            className="row center_me  border_radius"
            style={{
              padding: "1rem",
              marginTop: "20px",
              marginBottom: "20px",
              marginRight: "10px",
              marginLeft: "10px",
              gap: "1rem",
            }}
          >
            <TitleImage1 />
            <TitleText />
            <TitleImage2 />
          </div>
          <div
            className="row center_me  border_radius"
            style={{
              padding: "1rem",
              marginTop: "20px",
              marginBottom: "20px",
              marginRight: "10px",
              marginLeft: "10px",
              gap: "1rem",
              alignItems: "stretch",
            }}
          >
            <div
              className="background_3 border_radius"
              style={{
                border: "2px solid #0000FF",
                padding: "4px",
                flex: 1,
              }}
            >
              <Info1 />
            </div>
            <div
              className="background_3 border_radius"
              style={{
                border: "2px solid #0000FF",
                padding: "4px",
                flex: 1,
              }}
            >
              <Info2 />
            </div>
          </div>
          <Testimonials />
        </div>
        <div className="show-mobile">
          <TitleText />
          <style>{`
            .home-videos { display: flex; flex-direction: column; justify-content: center; }
            @media (min-width: 700px) { .home-videos { flex-direction: row; } }
          `}</style>
          <div className="home-videos">
            <TitleImage1 />
            <TitleImage2 />
          </div>
          <div
            className="background_3 border_radius"
            style={{
              border: "4px solid #0000FF",
              padding: "4px",
              flex: 1,
              margin: "20px",
            }}
          >
            <Info1 />
          </div>
          <div
            className="background_3 border_radius"
            style={{
              border: "4px solid #0000FF",
              padding: "4px",
              flex: 1,
              margin: "20px",
            }}
          >
            <Info2 />
          </div>
          <Testimonials />
        </div>
      </div>
      <Footer />
    </div>
  );
}

// UserProfile
//DONE//  Picture (Avatar)
//DONE//  Name
//DONE//  Account Source (Google/Apple/Email)
//DONE//  Payment Type (Stripe/Apple Store/Google Store/Exempt)
//DONE//  FK user state
//DONE//  created time
//DONE//  write time
//DONE//  last sign in
//NOPE//  last access time
//DONE// Account State

// StripeUpdates
//DONE//  id
//DONE//  data
//DONE//  event_type
//DONE//  result
//DONE//  write_time

// AccountState
//  Create
//  TrialUser
//  Monthly Level1
//  Monthly Level2
//  Monthly Level3
//  Yearly Level1
//  Yearly Level2
//  Yearly Level3
//  Cancelled Trial
//  Cancelled Paid
//  Deleted
//  Internal Test User
//  Admin User
//  External Test User

// UserStripeStatus
//  FK user
//  FK state
//  paid_thru_date
//  write_time
//  stripe_customer_id
//  stripe_subscription_id

// UserGoogleState
// UserAppleState

// or do we have all 3 in one table...
